<template>
  <div>
    <base-nav
      v-model="showMenu"
      type="light"
      :transparent="true"
      menu-classes="justify-content-end"
      class="navbar-horizontal navbar-main bg-gradient-clarity"
      expand="lg"
      :style="{'background': headerColor}"
    >
      <div slot="brand" class="navbar-wrapper">
        <b-button pill variant="outline-white" href="https://maps.mykajabi.com/products/pulse" v-if="user.pulse" class="mt-3">
          <div class="d-flex justify-content-between">
            <i class="fas fa-angle-left fa-2x mt-2"></i>
            <span>BACK TO THE PULSE <br />CLIENT PORTAL</span>
          </div>
        </b-button>
        <b-navbar-brand to="/" v-else>
          <img src="/img/brand/clarity-logo-white.png">
        </b-navbar-brand>
      </div>

     <template>
       <div class="navbar-collapse-header">
         <b-row>
           <b-col cols="6" class="collapse-brand">
             <router-link to="/">
               <img src="img/brand/clarity-logo-white.png">
             </router-link>
           </b-col>
           <b-col cols="6" class="collapse-close">
             <button type="button" class="navbar-toggler" @click="showMenu = false">
               <span></span>
               <span></span>
             </button>
           </b-col>
         </b-row>
       </div>
       <hr class="d-lg-none">
       <b-navbar-brand to="/dashboard" v-if="user.pulse">
         <img src="/img/brand/clarity-logo-white.png">
       </b-navbar-brand>
       <b-navbar-nav  class="align-items-lg-center ml-lg-auto" v-else>
        <base-dropdown class="nav-item"
                       tag="li"
                       title-classes="nav-link"
                       title-tag="a"
                       :icon="notifications.length > 0 ? 'fas fa-bell fa-beat-fade' : 'fas fa-bell'"
                       menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden">
          <template>
            <!-- Dropdown header -->
            <div class="px-3 py-3">
              <h6 class="text-sm text-muted m-0">You have <strong class="text-primary">{{ notifications.length }}</strong> notifications.</h6>
            </div>
            <!-- List group -->
            <b-list-group flush>
              <b-list-group-item action :to="'/notifications/' + notification.id" v-for="(notification, index) in notifications" :key="index">
                <b-row align-v="center">
                  <b-col>
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <h4 class="mb-0 text-sm">{{ notification.data.from }}</h4>
                      </div>
                      <div class="text-right text-muted">
                        <small>{{ new Date(notification.created_at) | date('M/d/Y h:mm a') }}</small>
                      </div>
                    </div>
                    <p class="text-sm mb-0">{{ notification.data.subject }}</p>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
            <!-- View all -->
            <!-- This item dont have <b-dropdown-item> because item have styles " text-center text-primary font-weight-bold py-3" on tag <a> wich we cant add -->
            <b-link href="#" to="/notifications" class="dropdown-item text-center text-primary font-weight-bold py-3">View all</b-link>
          </template>
        </base-dropdown>
        <base-dropdown menu-classes="dropdown-menu-lg dropdown-menu-right"
                       class="nav-item"
                       tag="li"
                       title-tag="a"
                       title-classes="nav-link"
                       icon="ni ni-settings-gear-65">
          <template>
            <b-row class="shortcuts px-4">
              <a href="/account-settings" class="col-6 shortcut-item">
                      <span class="shortcut-media avatar rounded-circle bg-gradient-red">
                        <i class="ni ni-settings"></i>
                      </span>
                <small>Account Settings</small>
              </a>
              <a href="/certifications" class="col-6 shortcut-item">
                      <span class="shortcut-media avatar rounded-circle bg-gradient-orange">
                        <i class="ni ni-paper-diploma"></i>
                      </span>
                <small>Certifications</small>
              </a>
            </b-row>
            <b-row class="shortcuts px-4">
              <a href="/integrations" class="col-6 shortcut-item">
                      <span class="shortcut-media avatar rounded-circle bg-gradient-info">
                        <i class="fas fa-network-wired"></i>
                      </span>
                <small>Integrations</small>
              </a>
              <a href="/video-library" class="col-6 shortcut-item" target="_blank">
                      <span class="shortcut-media avatar rounded-circle bg-gradient-green">
                        <i class="ni ni-books"></i>
                      </span>
                <small>Video Library</small>
              </a>
            </b-row>
          </template>
        </base-dropdown>
         <base-dropdown menu-on-right
                        class="nav-item"
                        tag="li"
                        title-tag="a"
                        title-classes="nav-link pr-0">
           <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
             <b-media no-body class="align-items-center">
               <span class="avatar avatar-sm rounded-circle">
                 <img alt="Image placeholder" :src="avatar">
               </span>
               <b-media-body class="ml-2 d-none d-lg-block">
                 <span class="mb-0 text-sm  font-weight-bold"> {{ user.name }}</span>
               </b-media-body>
             </b-media>
           </a>

           <template>

             <b-dropdown-header class="noti-title">
               <h6 class="text-overflow m-0">Welcome!</h6>
             </b-dropdown-header>
             <b-dropdown-item @click="goToAccount">
               <i class="fas fa-cog"></i>
               <span>Account Settings</span>
             </b-dropdown-item>
             <div class="dropdown-divider"></div>
             <b-dropdown-item @click.prevent="logout()">
               <i class="ni ni-user-run"></i>
               <span>Logout</span>
             </b-dropdown-item>

           </template>
         </base-dropdown>
       </b-navbar-nav>
     </template>
    </base-nav>

    <div class="main-content">
      <zoom-center-transition
        :duration="pageTransitionDuration"
        mode="out-in"
      >
        <router-view></router-view>
      </zoom-center-transition>
    </div>

    <footer class="py-5" id="footer-main">
      <b-container >
        <b-row align-v="center" class="justify-content-xl-between">
          <b-col xl="6">
            <div class="copyright text-center text-xl-left text-muted">
              © {{year}} <a href="https://www.claritynowre.com" class="font-weight-bold ml-1" target="_blank">ClarityNOW, Inc</a>
            </div>
          </b-col>
          <b-col xl="6" class="col-xl-6">
            <b-nav  class="nav-footer justify-content-center justify-content-xl-end">
              <b-nav-item href="https://www.claritynowre.com" target="_blank">
                ClarityNOW, Inc
              </b-nav-item>
              <b-nav-item href="https://www.claritynowre.com" target="_blank">
               About Us
              </b-nav-item>
              <b-nav-item href="https://www.claritynowre.com/privacy-policy" target="_blank">
                Privacy
              </b-nav-item>
              <b-nav-item href="https://www.claritynowre.com/terms-and-conditions" target="_blank">
                Terms
              </b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';
  import { BaseNav } from '@/components';
  import { ZoomCenterTransition } from 'vue2-transitions';

  export default {
    components: {
      BaseNav,
      ZoomCenterTransition
    },
    props: {
      backgroundColor: {
        type: String,
        default: 'black'
      }
    },
    data() {
      return {
        showMenu: false,
        menuTransitionDuration: 250,
        pageTransitionDuration: 200,
        year: new Date().getFullYear(),
        pageClass: 'login-page'
      };
    },
    computed: {
      title() {
        return `${this.$route.name} Page`;
      },
      ...mapGetters({
        user: 'profile/user',
        isAuthenticated: 'isAuthenticated',
        avatar: 'profile/avatar',
        notifications: 'notifications/notifications',
        affiliate: 'profile/affiliate',
        enterprise: 'profile/enterprise',
      }),
      headerColor() {
        if (this.user.pulse) {
          return 'linear-gradient(87deg, #262262 40%, #DDB143 100%) !important';
        }

        if (this.enterprise) {
          return 'linear-gradient(87deg, ' + this.enterprise.primary_color + ' 40%, #aaaaaa 300%) !important';
        }

        if (this.affiliate) {
          'linear-gradient(87deg, ' + this.affiliate.header_color + ' 40%, #aaaaaa 300%) !important';
        }

        return '';
      }
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open');
        this.showMenu = !this.showMenu;
      },
      closeMenu() {
        document.body.classList.remove('nav-open');
        this.showMenu = false;
      },
      setBackgroundColor() {
        document.body.classList.add('bg-secondary');
      },
      removeBackgroundColor() {
        document.body.classList.remove('bg-secondary');
      },
      updateBackground() {
        if (!this.$route.meta.noBodyBackground) {
          this.setBackgroundColor();
        } else {
          this.removeBackgroundColor()
        }
      },
      async logout() {
        axios.post(process.env.VUE_APP_API_BASE_URL + "/logout")
        .then(response => {
          if(response.status == 200) {
            this.$store.dispatch("logout", {email: this.userEmail});
          }
        })
        .catch(error => {

        });
      },
      goToAccount() {
        if(this.$route.name !== 'Account') {
          this.$router.push({
            path: '/account-settings'
          });
        }
      },
    },
    beforeDestroy() {
      this.removeBackgroundColor();
    },
    beforeRouteUpdate(to, from, next) {
      // Close the mobile menu first then transition to next page
      if (this.showMenu) {
        this.closeMenu();
        setTimeout(() => {
          next();
        }, this.menuTransitionDuration);
      } else {
        next();
      }
    },
    watch: {
      $route: {
        immediate: true,
        handler: function () {
          this.updateBackground()
        }
      }
    }
  };
</script>
<style lang="scss">
  .navbar {
    padding-top: 0rem;
  }
  $scaleSize: 0.8;
  @keyframes zoomIn8 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
      opacity: 1;
    }
  }

  .main-content .zoomIn {
    animation-name: zoomIn8;
  }

  @keyframes zoomOut8 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }

  .main-content .zoomOut {
    animation-name: zoomOut8;
  }

  .bg-gradient-clarity {
    background-image: linear-gradient(87deg, #3D5F71, #aaaaaa 300%) !important;
  }
</style>
